var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 1.25A1.75 1.75 0 0 0 1.25 3v6c0 .966.784 1.75 1.75 1.75h.778a.75.75 0 0 0 0-1.5H3A.25.25 0 0 1 2.75 9V3A.25.25 0 0 1 3 2.75h6a.25.25 0 0 1 .25.25v.778a.75.75 0 0 0 1.5 0V3A1.75 1.75 0 0 0 9 1.25H3zm4 4A1.75 1.75 0 0 0 5.25 7v6c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0 0 14.75 13V7A1.75 1.75 0 0 0 13 5.25H7zM6.75 7A.25.25 0 0 1 7 6.75h6a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25H7a.25.25 0 0 1-.25-.25V7z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;